import React, { useState, useEffect, useRef } from "react";
import "./Questionnare.scss";
import Divya from "./Divya.png";
import CheckSuccess from "./CheckSucces";
import DrawerClosee from "./DrawerClosee";
import { fetchQuestionnaireData } from "../api/getQuestionnaireData";
import { transformQuestions } from "../Utils";

const QuestionnaireResult = (props) => {
  const {
    isExpired,
    middleware,
    questionnaireId,
    platform = "FM",
    editQuestionnaire = () => {},
    score_Data = null,
    imageUrl,
    name,
    designation,
    showSideBar,
  } = props;
  const [questionnaire, setQuestionnaire] = useState(null);
  const [descExpanded, setDescExpanded] = useState(false);

  const [error, setError] = useState(null);
  useEffect(() => {
    const getQuestionnaire = async () => {
      try {
        console.log("middleware", middleware, questionnaireId);
        const data = await fetchQuestionnaireData({
          middleware: middleware,
          questionnaireId: questionnaireId,
        });
        setQuestionnaire(data);
      } catch (err) {
        setError(err);
      }
    };
    if (questionnaireId) {
      getQuestionnaire();
    }
  }, [questionnaireId]);
  const { height } = props;
  const questions = {
    score: 42,
    passPercentage: 42,
    candidateQuestionnaire: {
      Question5: null,
      LongQuestion: {
        marks: "0",
        question: "Long qqq",
        answer: "qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq",
      },
      Question4: {
        marks: "0",
        question: "Qq4qwertyuiopqwertyuiopqwertyuiopqwertyuiopqwertyuiop",
        answer: "no",
      },
      Question3: {
        marks: "25",
        question: "Qq3qwertyuiopqwertyuiopqwertyuiopqwertyuiopqwertyuiop",
        answer: "no",
      },
      Question2: {
        marks: "20",
        question: "Qq2qwertyuiopqwertyuiopqwertyuiopqwertyuiopqwertyuiop",
        answer: "no",
      },
      Question1: {
        marks: "0",
        question: "Qq1qwertyuiopqwertyuiopqwertyuiopqwertyuiopqwertyuiop",
        answer: "no",
      },
    },
  };

  const correctQuestions = {
    "Passing Marks": "45",
    "Long Question": {
      question: "Explain the importance of accessibility in web design.",
      answer:
        "Accessibility ensures that all users, including those with disabilities, can interact with a website effectively.",
      marks: "25",
    },
    "Questionnaire Description":
      "What are the key differences between UI (User Interface) and UX (User Experience) design.What are the key differences between UI (User Interface) and UX (User Experience) design.What are the key differences between UI (User Interface) and UX (User Experience) design.What are the key differences between UI (User Interface) and UX (User Experience) design.",
    "Questionnaire Name": "salesforce developer",
    "Question 1": {
      question: "Are you willing to relocate?",
      answer: "yes",
      marks: "100",
    },
    "Question 2": {
      question: "Have you worked with APIs in Salesforce?",
      answer: "no",
      marks: "80",
    },
    "Question 3": {
      question: "What is your experience with Agile methodology?",
      answer: "I have worked in Agile teams for 3 years.",
      marks: "50",
    },
    "Question 4": {
      question: "Describe a challenging UI/UX problem you solved.",
      answer: "I redesigned a checkout process, reducing drop-offs by 30%.",
      marks: "30",
    },
  };

  const transformedData = transformQuestions(questionnaire,score_Data);

  console.log({ transformedData });

  return (
    <div style={{ height: height }} className="questionnaire-container">
      <div className="questionnaire-header">
        {platform !== "MJP" ? "View Score" : "Questionnaire"}
      </div>
      {/* <hr /> */}
      <div className="questionnaire-Profile">
        {platform !== "MJP" && (
          <>
            <div
              className="questionnaire-Profile-innerBox"
              style={{ backgroundColor: "#fff" }}
            >
              <img
                src={imageUrl}
                alt="Profile"
                className="questionnaire-Profile-image"
              />
              <div className="questionnaire-Profile-Detail">
                <span className="questionnaire-Profile-Name">{name}</span>
                {!!designation && (
                  <span className="questionnaire-Profile-Role">
                    {designation}
                  </span>
                )}
              </div>
{transformedData &&
              <div className="score-badge" style={{color:transformedData["passPercentage"]>transformedData["Passing Marks"]?"#E03923":"",backgroundColor:transformedData["passPercentage"]>transformedData["Passing Marks"]?"#FCEBE9":""}}>
                Score:{" "}
                <span className="color-228568 ml5" style={{color:transformedData["passPercentage"]>transformedData["Passing Marks"]?"#E03923":""}}>
                  {
                    transformedData["Passing Marks"] &&
                    transformedData["Passing Marks"]}
                </span>
                <span className="font400" style={{color:"#59566C"}}>/100</span>
              </div>
}
            </div>

            {/* <hr /> */}
          </>
        )}
        <div className="pd16 bg-Color-f8f9fd">
          <div className="questionnaire-header-row">
            <div className="font600 fs12 lh16">
              {transformedData && transformedData["Questionnaire Name"]}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                lineHeight: "16px",
                height: "24px",
                padding: "4px 0px",
              }}
            >
              <span style={{ marginRight: "8px" }}>
                <span className="font400 fs12 color-59566c">
                  Total questions:
                </span>
                <span className="font500 fs12">
                  {" "}
                  {transformedData &&
                    transformedData.Questions &&
                    transformedData.Questions.length}
                </span>
              </span>
              {platform == "MJP" && (
                <>
                  <div
                    style={{
                      height: 16,
                      width: 1,
                      backgroundColor: "#D2D1D6",
                      display: "inline-block",
                      borderRadius: "5px",
                      marginRight: 9,
                      marginTop: 5,
                      position: "relative",
                    }}
                  ></div>
                  <span>
                    <span className="font400 fs12 color-59566c">
                      Pass Marks:
                    </span>
                    <span className="font500 fs12 ml5">
                      {transformedData &&
                        transformedData["Passing Marks"] &&
                        transformedData["Passing Marks"]}
                      /100
                    </span>
                  </span>
                </>
              )}
            </div>
          </div>
          {transformedData && transformedData["Questionnaire Description"] && (
            <div
              className="mt12 color-777584 flex"
              style={{ textAlign:"left" }}
            >
              {!descExpanded ? (
                <div style={{ position: "relative" }}>
                  <div className="font400 fs12 lh16 line-clamp-container">
                    {transformedData["Questionnaire Description"]}
                  </div>
                  <span
                    className="color-59566c underline_quest fadeout-readmore pointer font400 fs12 lh16"
                    onClick={() => setDescExpanded(true)}
                  >
                    Read more
                  </span>
                </div>
              ) : (
                <div>
                  <span
                    className="font400 fs12 lh16"
                    style={{ textAlign: "left", whiteSpace: "normal" }}
                  >
                    {transformedData["Questionnaire Description"]}
                  </span>
                  <span
                    className="color-59566c pointer underline_quest font400 fs12 lh16 mt4"
                    onClick={() => setDescExpanded(false)}
                  >
                    Read less
                  </span>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="bg-Color-f8f9fd pd16">
          {(transformedData.Questions || []).map((q) => (
            <div
              key={q.id}
              style={{
                minHeight: "70px",
              }}
              className="bg-Color-fff rd-8 pd8 mt12"
            >
              <div className="question-box pd8-0">
                {q.type === "Descriptive" && platform == "MJP" && (
                  <div
                    style={{
                      padding: "4px 8px",
                      background: " #F6F6F7",
                      borderRadius: "4px",
                      width: "fit-content",
                    }}
                  >
                    <div
                      style={{
                        color: "#777584",
                        fontSize: "12px",
                        fontFamily: "Noto Sans",
                        fontWeight: 400,
                        lineHeight: "16px",
                        wordWrap: "break-word",
                      }}
                    >
                      Essay/long answer question
                    </div>
                  </div>
                )}
                <div className="question-box-inner fs12 font400">
                  <span>Q{q.id}.</span>
                  <span> {q.question}</span>
                </div>
                {q.type === "Objective" && (
                  <div className="fs12 font400 lh16 question-box-inner-objective">
                    <div
                      style={{
                        display: "flex",
                        // , alignItems: "center"
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginRight: "8px",
                          gap: "8px",
                        }}
                      >
                        {platform === "FM" ? (
                          <div style={{ height: 16, width: 16 }}>
                            {q.points === "0" || q.points === 0 ? (
                              <DrawerClosee />
                            ) : (
                              <CheckSuccess />
                            )}
                          </div>
                        ) : (
                          <>
                            <div style={{ height: 16, width: 16 }}>
                              {q.option === "A" && <CheckSuccess />}
                            </div>
                            <div style={{ height: 16, width: 16 }}>
                              {q.option === "B" && <CheckSuccess />}
                            </div>
                          </>
                        )}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          color: "#59566C",
                          gap: "8px",
                          marginLeft: "4px",
                        }}
                      >
                        {platform === "FM" ? (
                          <span>{q.option === "A" ? "A. Yes" : "B. No"}</span>
                        ) : (
                          <>
                            <span>A. Yes</span>
                            <span>B. No</span>
                          </>
                        )}
                      </div>
                    </div>

                    <span
                      style={{ marginLeft: "auto", marginTop: "auto" }}
                      className="fs12 font400 color-59566c"
                    >
                      {platform == "MJP" && "Assigned"} Points:{" "}
                      <span className="color-17142a">{q.points}</span>
                    </span>
                  </div>
                )}

                {q.type === "Descriptive" && platform !== "MJP" && (
                  <div className="fs12 font400 color-59566c mt8 pl40">
                    {q.value}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      {platform == "MJP" && !!showSideBar && !isExpired && (
        <div className="bg-Color-fff bottom-div" onClick={editQuestionnaire}>
          <div
            className="bottom-button"
            onClick={() => {
              if (questionnaire.questionnaireId) {
                window.open(
                  `https://recruiter.foundit.in/edge/jobposting/create-questionnaire/edit/${questionnaire.questionnaireId}`,
                  "_blank"
                );
              }
            }}
          >
            Edit Questionnaire
          </div>
        </div>
      )}
    </div>
  );
};
export default QuestionnaireResult;
